import { FolkSpaceAttribute } from '../folk-space-attribute';
FolkSpaceAttribute.define();
export { FolkSpaceAttribute };
//# sourceMappingURL=folk-space-attribute.js.map